import React, { useRef, useState } from 'react';
import {
  Button,
  Panel,
  PanelProps,
  Spinner
} from '@walmart-web/livingdesign-components';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

import styles from './styles.module.css';
import useReachedToBottom from '../../hooks/useReachedToBottom.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { ihutSelectors } from '../../redux/slices/ihut.ts';

type Props = {
  bodyContent: string;
  onClose: () => unknown;
  handleReadClick: () => unknown;
  disabled?: boolean;
} & Pick<PanelProps, 'position' | 'isOpen' | 'title'>;

const BodyContent = ({ text, handleReachedToBottom }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  useReachedToBottom(containerRef, handleReachedToBottom);
  return (
    <div className={styles.bodyContainer} ref={containerRef}>
      {parse(text)}
    </div>
  );
};

const InstructionsSidePanel: React.FC<Props> = ({
  bodyContent,
  isOpen,
  handleReadClick,
  disabled = false,
  ...restProps
}) => {
  const { t } = useTranslation('common');
  const updateStateLoading = useAppSelector(
    ihutSelectors.selectUpdateStateLoading
  );
  const [reachedToBottom, setReachedToBottom] = useState(false);

  const handleReachedToBottom = () => {
    setReachedToBottom(true);
  };

  return (
    <Panel
      isOpen={isOpen}
      actions={
        <Button
          variant="primary"
          isFullWidth
          disabled={!reachedToBottom || updateStateLoading || disabled}
          onClick={handleReadClick}
        >
          {updateStateLoading ? (
            <Spinner size="small" />
          ) : (
            t('haveReadInstructions')
          )}
        </Button>
      }
      size="small"
      UNSAFE_className={styles.sidePanelContainer}
      {...restProps}
    >
      <BodyContent
        text={bodyContent}
        handleReachedToBottom={handleReachedToBottom}
      />
    </Panel>
  );
};

export default InstructionsSidePanel;
